// extracted by mini-css-extract-plugin
export default {"section":"_0TAnZ"};